import request from '@/utils/request'
const baseUrl = '/material'

/**
 * 素材板块 API
 */

/**
 * 获取一个临时的token用于客户端获取明文解密key
 */
export function temporary() {
  return request({
    url: `/drm/hls/temporary`,
    method: 'GET'
  })
}

/**
 * 获取一个临时的token用于客户端获取明文解密key
 */
export function verifiedUpload(data) {
  return request({
    url: `${baseUrl}/private/rest/verifiedUpload`,
    method: 'POST',
    data
  })
}

/**
 * 获取一个临时的token用于客户端获取明文解密key
 */
export function getList(data) {
  return request({
    url: `${baseUrl}/private/list`,
    method: 'POST',
    data
  })
}

/**
 * 获取官方设置的素材的标签:1是video,2是music,3是picture,4是template,5是other
 */
export function getMaterialTags(type) {
  return request({
    url: `${baseUrl}/private/rest/getMaterialTags/${type}`,
    method: 'GET'
  })
}

/**
* 获取自己设置的素材的标签:1是video,2是music,3是picture,4是template,5是other
*/
export function getOwnMaterialTags(type) {
  return request({
    url: `${baseUrl}/private/rest/getOwnMaterialTags/${type}`,
    method: 'GET'
  })
}

/**
* 获取顶部底部标签:1是video,2是music,3是picture,4是template,5是other
*/
export function getCourseKeyword(data) {
  return request({
    url: `${baseUrl}/rest/courseKeyword/list`,
    method: 'POST',
    data
  })
}
/**
* 视频详情页
*/
export function getVideoDetail(id) {
  return request({
    url: `${baseUrl}/private/player/video/${id}`,
    method: 'GET'
  })
}

/**
 * 图片详情页
 */
export function getPictureDetail(id) {
  return request({
    url: `${baseUrl}/private/player/picture/${id}`,
    method: 'GET'
  })
}

/**
 * 按作者推荐素材
 */
export function getRecommend(id) {
  return request({
    url: `${baseUrl}/rest/creator/recommend/${id}`,
    method: 'POST',
    data: {
      pageIndex: 1,
      pageSize: 100
    }
  })
}

/**
 * 按分类推荐素材
 */
export function getRecommend2(id) {
  return request({
    url: `${baseUrl}/rest/keyword/recommend/${id}`,
    method: 'POST',
    data: {
      pageIndex: 1,
      pageSize: 100
    }
  })
}

/**
 * 收藏/取消收藏素材
 */
export function collect(materialId) {
  return request({
    url: `${baseUrl}/private/rest/collect/${materialId}`,
    method: 'GET'
  })
}

/**
 * 评论
 */
export function comment(data) {
  return request({
    url: `${baseUrl}/private/rest/comment/${data.id}`,
    method: 'POST',
    data
  })
}

/**
 * 评论列表
 */
export function getCommentList(id) {
  return request({
    url: `${baseUrl}/rest/commentList/${id}`,
    method: 'POST',
    data: {
      pageIndex: 1,
      pageSize: 100
    }
  })
}

/**
 * 删除评论
 */
export function deleteComment(id) {
  return request({
    url: `${baseUrl}/private/rest/comment/delete/${id}`,
    method: 'POST'
  })
}

/**
 * 编辑素材
 */
export function getUpdateMaterial(id) {
  return request({
    url: `${baseUrl}/private/rest/getUpdateMaterial/${id}`,
    method: 'GET'
  })
}

/**
 * 更新视频素材
 */
export function updateVideoMaterial(data) {
  return request({
    url: `${baseUrl}/private/rest/updateVideoMaterial`,
    method: 'POST',
    data
  })
}

/**
 * 更新除了视频素材的其它素材
 */
export function updateTemplateMaterial(data) {
  return request({
    url: `${baseUrl}/private/rest/updateTemplateMaterial`,
    method: 'POST',
    data
  })
}

/**
 * 加入购物车
 */
export function addShoppingCart(data) {
  return request({
    url: `${baseUrl}/private/rest/shoppingCart/add`,
    method: 'POST',
    data
  })
}

/**
 * 加入购物车
 */
export function shareMaterial(id) {
  return request({
    url: `${baseUrl}/rest/share/${id}`,
    method: 'POST'
  })
}

/**
 * 投诉
 */
export function createReport(data) {
  return request({
    url: `${baseUrl}/private/rest/createReport`,
    method: 'POST',
    data
  })
}

/**
 * 获取虚拟资产标签
 */
export function getVirtualTags() {
  return request({
    url: `${baseUrl}/rest/materialKeyword/list/vp`,
    method: 'POST',
  })
}
